import { render, staticRenderFns } from "./CanvasTree.template.vue?vue&type=template&id=28862558&scoped=true&"
var script = {}
import style0 from "./CanvasTree.template.vue?vue&type=style&index=0&id=28862558&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28862558",
  null
  
)

export default component.exports